import store from "@/store";

export const API_DOMAIN = process.env.VUE_APP_API_URL;

export function buildUrl(uri, params = []) {
  const appConfiguration = store.getters["auth/appConfiguration"];
  const baseUrl = (appConfiguration?.apiEndPoint || API_DOMAIN || "").replace(/\/+$/, "");
  const path = String(uri).replace(/^\/+/, "");
  const query = params.length > 0 ? `?${params.join("&")}` : "";
  return `${baseUrl}/${path}${query}`;
}
